import {browserHistory} from 'react-router';
import axios from 'axios';

const baseEndpoint = 'v1/automaticmessages';

const AutomaticMessageService = {

  deleteAutomaticMessage( id ) {
    return axios
      .delete( `${baseEndpoint}/${id}` )
  },

  getAutomaticMessages( params ) {
    return axios
      .get( baseEndpoint, { params } )
  },

  getAutomaticMessage( id ) {
    return axios
      .get( `${baseEndpoint}/${id}` )
  },

  saveAutomaticMessage( data ) {
    return axios
      .post( baseEndpoint, data )
  },

  updateAutomaticMessage( id, data ) {
    return axios
      .put( `${baseEndpoint}/${id}`, data )
  },
};

export default AutomaticMessageService;



// WEBPACK FOOTER //
// ./services/AutomaticMessageService.js